// extracted by mini-css-extract-plugin
export default {"hello":"Hello_hello__M+pPf"};